import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import * as React from 'react';

var useBoolean = function useBoolean() {
  var initialState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  var _React$useState = React.useState(initialState),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      value = _React$useState2[0],
      setValue = _React$useState2[1];

  var setFalse = React.useCallback(function () {
    setValue(false);
  }, [setValue]);
  var setTrue = React.useCallback(function () {
    setValue(true);
  }, [setValue]);
  var toggle = React.useCallback(function () {
    setValue(function (currentValue) {
      return !currentValue;
    });
  }, [setValue]);
  return {
    value: value,
    setTrue: setTrue,
    setFalse: setFalse,
    toggle: toggle
  };
};

export { useBoolean };